module.exports = __webpack_public_path__ + "img/monitor-bg.9a3b45f2.png";